import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _EcmDocument, _QualityReprocessing, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { ProductionOrderEditor } from "../../ProductionOrder/ProductionOrderEditor";
import { PdfDocuments } from "../../../documents/PdfDocuments";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { QualityReprocessingItem } from "./QualityReprocessingItem/QualityReprocessingItem";
import usePaginator from "../../../theme/Component/usePaginator";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { ImportXLSX } from "../../../theme/Component/ImportXLSX";
import { PrintJson } from "../../../theme/Component/PrintJson";

interface PropsComponent {
    isModal?: boolean;
}

export const QualityReprocessing = ({ isModal }: PropsComponent) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityReprocessing);
    const paginator = usePaginator();

    const [data, setData] = useState<any>();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalReprocess = useModal(`Reprocesos`, MODAL_LG)
    const modalDocument = useModal("Solicitar flujo de firmas", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);
    const modalImport = useModal("Importar Información", MODAL_SM);

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getQualityReprocessingRender(paginator.page, 15, year, props).then((resp: any) => {
            paginator.setPages(resp.NumberOfPages);
            paginator.setRecords(resp.NumberOfPages * 15);
            resp.List.forEach(element => {
                const data = element.DataBeanProperties;

                data.RollerEntity = data.IDAccountRoller ? `${data.AccountRollerNit} - ${data.AccountRollerFullName}` : "N/A"
                data.POEntity = data.IDProductionOrder ? `${data.IDProductionOrder} - ${data.ProductionOrderDate}` : "N/A"
            });
            setLista(resp.List)
        }).catch(err => {
            toast.error("Error al cargar la lista Tipos de errores");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar Revision de Patinador`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateQualityReprocessing(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const importData = () => {
        instance.importReprocessReviews(_single.getAccountID(), JSON.stringify(data)).then(
            (resp: any) => {
                getLista();
                modalImport.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityReprocessing', visible: true },
        { title: 'Fecha de Revision', property: 'ReviewDate', visible: true },
        { title: 'Turno', property: 'WorkShiftName', visible: true },
        { title: 'Orden de Producción', property: 'POEntity', visible: true },
        { title: 'Ruta', property: 'ProductionRouteName', visible: true },
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Patinador', property: 'RollerEntity', visible: true },
        { title: 'Tiempo total de Reproceso', property: 'TotalQuantityLabor', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Importar', visible: _single.canCreate(), icono: 'ri-file-upload-line', evento: () => { modalImport.open() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Solicitar Aprobaciones', icono: 'mdi mdi-signature-text', visible: _single.canEdit(), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.IDDocument, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Reprocesos', icono: 'ri-list-check', visible: true, evento: () => { modalReprocess.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "ReviewDate", "IDWorkShift", "IDProductionOrder"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const validateDataSigned = () => {
        if (!signed.bean.IDSignPanel) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    }

    const signed = useDataBean(_EcmDocument);

    const createEcmDocumentForFlowControl = () => {

        const Obs = `Durante la inspección de Calidad del Proceso, para la produccion del producto, se presentaron los reprocesos con sus respectivas observaciones, danto como resultado un tiempo total de  en reprocesos`

        signed.instance.createEcmDocumentForFlowControl(signed.bean.IDSignPanel, _single.getAccountID(), Obs, null, null, null, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                if (resp.IDDocument > 0) {
                    signed.instance.fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, signed.bean.IDSignPanel, _single.getAccountID()).then(
                        (resp: any) => {
                            toast.success(resp);
                            console.log(resp)
                        }
                    ).catch(
                        err => {
                            toast.error("No se pudo iniciar proceso de firmas")
                        }
                    )
                    editaItem({ ...bean, IDDocument: resp.IDDocument, DocumentDate: resp.DocumentDate })
                } else {
                    toast.error("No se genero documentoa firmar")
                }
            }).catch(
                err => { toast.error(err) }
            )
    }

    const [year, setYear] = useState<number>(_single.getCurrenYear())

    const rowContent = (
        <div className="row">
            <div className="col-md-6">
                <YearSelector tittle="Año de Orden de Producción" onChange={(e) => { setYear(e) }} value={year} />
            </div>
            <div className="col-md-3">
                <BasicButton eventClick={() => { getLista(); }} icon="ri-search-line" children={`Buscar`} useMargin />
            </div>
            <div className="col-md-12">
                <BasicTable
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    iconButtons={iconButtonsItem}
                />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDAccountRoller') ? 'has-error' : ''}`} >Patinador</label>
                            <AccountEditor idAccount={bean.IDAccountRoller} label=" " onChange={(e) => { setBean({ ...bean, IDAccountRoller: e.IDAccount }) }} />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('ReviewDate') ? 'has-error' : ''}`} >Fecha de Revisión</label>
                            <InputDate name="" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} label=" " />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDWorkShift') ? 'has-error' : ''}`} >Turno de Trabajo</label>
                            <SelectTHConstantsValue label=" " code={904} onChange={(e) => { setBean({ ...bean, IDWorkShift: e }) }} value={bean.IDWorkShift} />
                        </div>
                        <div className="col-md-12">
                            <ProductionOrderEditor _renderValue={bean.POEntity} IDOrderProduction={bean.IDProductionOrder} returnData={(e) => { setBean({ ...bean, IDProductionOrder: e.IDProductionOrder}) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.TechnicianName}</strong>
                </ModalConfirm>

                <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { validateDataSigned() }}  >
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                        <SingPanelEditor idSelector={signed.bean.IDSignPanel} label=" " onChange={(e) => { signed.setBean({ ...signed.bean, "IDSignPanel": e }) }} />
                    </div>
                </Modal>

                <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                    <PdfDocuments documentLocation={bean.IDDocument} date={bean.DocumentDate} mnemonic="ECM" />
                </Modal>

                <Modal modal={modalReprocess.modal} updateModal={modalReprocess.setModal}   >
                    <QualityReprocessingItem QualityReprocessing={bean} />
                </Modal>

                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={() => { importData() }}  >
                    <ImportXLSX lodaData={setData} />
                    {/* <PrintJson json={data} /> */}
                </Modal>
            </div>
        </div>
    )


    return isModal ? rowContent : (
        <BasicPage titulo="Lista de Reprocesos">
            {rowContent}
        </BasicPage>
    )
}